import * as DateSelector from '../../components/date-selector'
import * as Request from '../../request'
import * as Constants from './constants'

export const fetchImports: DateSelector.DatedInformationActionCreator =
  (community: DateSelector.CommunityIdentifier, date: DateSelector.SelectedDate) =>
    Request.requestActionCreator<DateSelector.DatedInformationPayload>(Constants.FETCH_IMPORTS)
      ({
        method: 'GET',
        payload: { selectedDate: date },
        url: `${Constants.SERVER_RESOURCE}/${community}/${date.format('YYYY-MM-DD')}`,
      })



// WEBPACK FOOTER //
// ./src/pages/imports/actions.ts